import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/doopage-react-ui-kit/doopage-react-ui-kit/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Playground } from "docz";
import { Button, setTheme, useTheme, Input } from "../index";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "theme"
    }}>{`Theme`}</h1>
    <h2 {...{
      "id": "basic-usage"
    }}>{`Basic usage`}</h2>
    <p>{`Set theme color before render App
Color must following formats: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla().`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import { setTheme } from '@doopage/react-ui-kit'

setTheme({
  primaryColor: '#551A8B',
})

ReactDOM.render(<App/>, document.getElementById("root"));
`}</code></pre>
    <p>{`To get theme`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import { getTheme } from '@doopage/react-ui-kit'
const theme = getTheme()
`}</code></pre>
    <p>{`useTheme`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import { useTheme } from '@doopage/react-ui-kit'
const MyComponent = () => {
  const theme = useTheme()
    return (
      <div>{theme.primaryColor}</div>
    )
}
`}</code></pre>
    <h2 {...{
      "id": "playground"
    }}>{`Playground`}</h2>
    <Playground __position={0} __code={'{setTheme({\n  primaryColor: \'#551A8B\',\n})}\n<Button color=\"primary\">Purple button</Button>\n<Input variant=\"outlined\" label=\"purple input\" />'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Button,
      setTheme,
      useTheme,
      Input,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
  {setTheme({
        primaryColor: '#551A8B'
      })}
  <Button color='primary' mdxType="Button">
    Purple button
  </Button>
  <Input variant="outlined" label='purple input' mdxType="Input" />
    </Playground>
    <Playground __position={1} __code={'() => {\n  const theme = useTheme()\n  return (\n    <>\n      <Button color=\"primary\">{theme.primaryColor}</Button>\n    </>\n  )\n}'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Button,
      setTheme,
      useTheme,
      Input,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
  {() => {
        const theme = useTheme();
        return <>
        <Button color='primary' mdxType="Button">
          {theme.primaryColor}
        </Button>
      </>;
      }}
    </Playground>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      